import PropTypes from 'prop-types';

const GoogleMapLink = ({ option }) => {
  const { address, latitude, longitude } = option || {};
  if (!address && !latitude) {
    return null;
  }

  const hrefSuffix = latitude ? `${latitude},${longitude}` : address;
  return (
    <div>
      <a
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURI(
          hrefSuffix
        )}`}
        target="_blank"
        className="link-primary text-small"
        rel="noopener noreferrer"
      >
        View in Google Maps
      </a>
    </div>
  );
};

GoogleMapLink.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    address: PropTypes.string,
  }),
};

export default GoogleMapLink;
